// import { callGet, callPost, callPutById, callDelete } from "../integrations/calls";
import { callGet, callPut } from "../integrations/calls";


import { REQ } from "../../libs/constants";

export const getSiteRefrence = async (token) => {
    return await callGet(REQ.REFRENCES.GET_STITE_NAME, token);
};

export const updateRefrence = async (data, token) => {
    return await callPut(`${REQ.REFRENCES.UPDATE_REFRENCES}/${data.siteId}`, data, token)
}